import { IoAddSharp } from "react-icons/io5";
import { Button, Modal, notification } from "antd";
import React, { useState } from "react";
import { roles, subRoles } from "../../../utils/constants";
import CustomForm from "../CustomForm";
import { http } from "../../../engine/api/http";
import { sendEmailInvitation } from "../../../engine/api/apiRequest";
import { modalApplicantIntervenantInputs } from "./ModalApplicantIntervenantInputs";
import { useTranslation } from "react-i18next";

export const CreateApplicant = ({
  formRef,
  onCreated,
  name,
  institution,
  opener,
  disabled,
}) => {
  const { t } = useTranslation(); // Translation hook
  const [open, setOpen] = useState(false);

  const onSubmitForm = async data => {
    try {
      if (name === "applicant") {
        let institutionRef = formRef.current.getFieldValue("institution");

        data.institution = institutionRef;
        data.role = roles.institution;
        data.subRoles = subRoles.institutionDemander; // applicant
      } else {
        data.institution = institution;
      }

      data.customerId = process.env.CUSTOMER_ID;

      let url = "";

      if (name === "intervenant") {
        url = "responsables/new";
      } else {
        url = "users/new";
      }

      const create = await http.post(url, data);
      if (create.status === 200) {
        if (create?.data === "Invalid email address") {
          notification.error({
            message: t("CreateApplicant.errorInvalidEmail"),
          });
        } else {
          onCreated(create?.data._id, create?.data);
          if (name === "applicant") {
            formRef?.current?.setFieldsValue({ [name]: create?.data._id });
          }
          setOpen(false);
          notification.success({
            message: `${t(
              name === "applicant"
                ? "CreateApplicant.successApplicant"
                : "CreateApplicant.successResponsable",
            )}`,
          });
          if (data.invitation === true && name === "applicant") {
            await sendEmailInvitation(create?.data._id);
          }
        }
      }
    } catch (e) {
      if (e?.response?.status === 400) {
        notification.error({
          message: e?.response?.data?.message || t("CreateApplicant.error"),
          duration: 5000,
        });
      }
    }
  };

  return (
    <>
      <Modal
        title={t(
          name === "applicant"
            ? "CreateApplicant.modalTitleApplicant"
            : "CreateApplicant.modalTitleResponsable",
        )}
        centered
        open={open}
        onOk={() => setOpen(false)}
        footer={null}
        onCancel={() => setOpen(false)}
        width={1000}
      >
        <CustomForm
          disabled={disabled}
          dataSource={modalApplicantIntervenantInputs({ setOpen, name })}
          handleSubmit={data => onSubmitForm(data)}
          labelCol={24}
          wrapperCol={24}
        />
      </Modal>

      {opener === undefined && (
        <Button
          disabled={disabled}
          type={"primary"}
          size={"small"}
          style={{
            justifySelf: "flex-start",
            display: "flex",
          }}
          onClick={() => {
            setOpen(true);
          }}
          icon={
            <IoAddSharp
              style={{
                marginTop: "0px",
              }}
              size={25}
            />
          }
        >
          {t(
            name === "applicant"
              ? "CreateApplicant.buttonApplicant"
              : "CreateApplicant.buttonResponsable",
          )}
        </Button>
      )}

      {opener &&
        React.cloneElement(opener, {
          onClick: () => {
            setOpen(true);
          },
        })}
    </>
  );
};
